import clsx from "clsx";
import { ReviewSourceTypes } from "../../types/index.ts";
import { convertSnakeToTitleCase } from "../../utils/snake-to-capital.ts";
import AgentEditFieldListWithInlineSources from "./AgentEditFieldListWithInlineSources";
import AgentEditFieldWithInlineSources, {
  FieldValueWithInlineSources,
} from "./AgentEditFieldWithInlineSources";

export interface Props {
  fields: {
    title: string;
    value: any;
    placeholder: string;
    onChange: (value: FieldValueWithInlineSources[]) => void;
    isNumber?: boolean;
  }[];
  showHorizontal?: boolean;
  onSourceClick: (selectedSource: ReviewSourceTypes) => void;
  setListOfSourcesForSelectedSources: (
    selectedSource: ReviewSourceTypes[]
  ) => void;
  expandedView?: boolean;
  isDisabled?: boolean;
}

const CombinedAgentEditFieldWithInlineSources = ({
  fields,
  showHorizontal,
  onSourceClick,
  expandedView,
  isDisabled,
  setListOfSourcesForSelectedSources,
}: Props) => {
  return (
    <div
      className={`border-1 border-[#E4E4E7] rounded-md overflow-hidden flex items-stretch bg-white w-full ${
        showHorizontal ? "flex-row" : "flex-col"
      } ${!isDisabled ? "group-hover:border-zinc-400" : ""}`}
    >
      {fields.map((field, idx) => (
        <div
          className={clsx(
            "w-full h-auto",
            showHorizontal && idx > 0 && idx < fields.length && "border-l-1"
          )}
          key={idx}
        >
          {Array.isArray(field.value) ? (
            <AgentEditFieldListWithInlineSources
              fieldValueObjArray={field.value}
              placeholder={`Add ${convertSnakeToTitleCase(field.placeholder || field.title)}`}
              onChange={field.onChange}
              onSourceClick={onSourceClick}
              setListOfSourcesForSelectedSources={
                setListOfSourcesForSelectedSources
              }
              title={field.title}
              showTitle={true}
              noBorder={true}
              expandedView={expandedView}
              isDisabled={isDisabled}
            />
          ) : (
            <AgentEditFieldWithInlineSources
              fieldValueObj={field.value}
              onChange={(val) => field.onChange([val])}
              placeholder={`Add ${convertSnakeToTitleCase(field.placeholder || field.title)}`}
              onSourceClick={onSourceClick}
              setListOfSourcesForSelectedSources={
                setListOfSourcesForSelectedSources
              }
              title={field.title}
              noBorder={true}
              expandedView={expandedView}
              minRows={2}
              maxRows={999999}
              isDisabled={isDisabled}
              focusEnd={true}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default CombinedAgentEditFieldWithInlineSources;